import '../styles/az-issue.scss';
import AzIssue from './az-issue.vue';

/* istanbul ignore next */
AzIssue.install = function (Vue) {
  Vue.component(AzIssue.name, AzIssue);
};

export default AzIssue;
